<template>
  <FullScreen>
    <div class="flex flex-col items-center m-auto" style="width: 30%;">
      <not-found-icon></not-found-icon>
      <div class="my-10 text-center">
        <h1>Halaman Tidak Ditemukan</h1>
        <div class="my-5">
          <p style="line-height: 22px!important;">Halaman yang anda cari tidak ditemukan atau tidak ada,
  Kami akan mengarahkan anda untuk kembali</p>
        </div>
        <va-button type="primary" @click.prevent="goBack()">Kembali</va-button>
      </div>
    </div>
  </FullScreen>
</template>

<script>
const FullScreen = () => import('@/components/App/FullScreen')
const NotFoundIcon = () => import('@/components/Icon/NotFound')

export default {
  data() {
    return {
    }
  },
  methods: {
    goBack() {
      this.$router.push('/')
    },
  },
  components: { FullScreen, NotFoundIcon },
  created() {
  },
}
</script>

<style>

</style>
